// extracted by mini-css-extract-plugin
export default {"error_text":"field-error_error_text__1YvfL"};